import { NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TabelaComponent } from '../tabela/tabela.component';
import { PQREncargosSociaisDto } from '../../dtos';

@Component({
  selector: 'app-dialog-pqr-encargos-sociais',
  standalone: true,
  imports: [
    NgFor,
    MatDialogModule,
    MatButtonModule,
    TabelaComponent
  ],
  templateUrl: './dialog-pqr-encargos-sociais.component.html',
  styleUrl: './dialog-pqr-encargos-sociais.component.scss'
})
export class DialogPqrEncargosSociaisComponent{
  @Input() dadosTabela: PQREncargosSociaisDto[] = [];
}
